import { t } from '../i18n/index.ts';
import { ratePct, useTaxRates } from '../lib/taxes.ts';

/**
 * A tax rate picked from the business's own rates (Settings → Tax rates). A record that still
 * has a rate that was turned off shows it too, so saving it unchanged keeps it.
 */
export function TaxRateSelect({
  value,
  onChange,
  label,
  className = 'input',
  placeholder,
  invalid,
}: {
  value: number | '' | null | undefined;
  onChange: (rate: number) => void;
  label?: string;
  className?: string;
  /** An empty first choice ("Choose…") when no rate is picked yet. */
  placeholder?: string;
  invalid?: boolean;
}) {
  const { choices, all } = useTaxRates();
  const current = typeof value === 'number' ? value : null;
  const off = (r: number) => all.some((x) => !x.active && Math.abs(x.rate - r) < 0.001) && !all.some((x) => x.active && Math.abs(x.rate - r) < 0.001);
  return (
    <select
      className={className}
      aria-label={label}
      aria-invalid={invalid || undefined}
      value={current ?? ''}
      onChange={(e) => {
        if (e.target.value !== '') onChange(Number(e.target.value));
      }}
    >
      {placeholder !== undefined || current === null ? <option value="">{placeholder ?? t('tax.choose')}</option> : null}
      {choices(current).map((r) => (
        <option key={r} value={r}>
          {ratePct(r)}
          {off(r) ? ` (${t('tax.turned_off')})` : ''}
        </option>
      ))}
    </select>
  );
}
